import jStat from 'jstat';

export interface SumSquaredErrorsResult {
  data: number[];
  mean: number;
  sse: number;
  values: { value: number; deviation: number; squaredDeviation: number }[];
  interpretation: string;
}

/**
 * Calculates the Sum of Squared Errors (SSE)
 * Sum of squared deviations from the mean
 * @param data Array of numeric values
 * @returns SSE calculation result
 */
export function calculateSumSquaredErrors(data: number[]): SumSquaredErrorsResult {
  // Handle empty data case
  if (!data || data.length === 0) {
    return {
      data: [],
      mean: 0,
      sse: 0,
      values: [],
      interpretation: 'No data provided for calculation.'
    };
  }

  const sortedData = [...data].sort((a, b) => a - b);
  // Use jStat for reliable mean calculation
  const mean = jStat.mean(data);
  
  // Calculate individual deviations and squared deviations
  const values = data.map(value => {
    const deviation = value - mean;
    const squaredDeviation = Math.pow(deviation, 2);
    return {
      value,
      deviation,
      squaredDeviation
    };
  });
  
  // Calculate sum of squared errors
  const sse = values.reduce((sum, item) => sum + item.squaredDeviation, 0);
  
  return {
    data: sortedData,
    mean,
    sse,
    values,
    interpretation: `The Sum of Squared Errors (SSE) is ${sse.toFixed(2)}, representing the total squared deviation from the mean of ${mean.toFixed(2)}. Lower SSE values indicate data points are closer to the mean.`
  };
} 